import React from 'react'

const BrazilFlag = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2398_40882)">
      <circle cx="8" cy="8" r="8" fill="#24A148" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3L15 7.99999L8 13L8 3ZM8 3.00012L1 8.00011L8 13.0001L8 3.00012Z"
        fill="#F3D603"
      />
      <circle cx="8" cy="8" r="3" fill="#012775" />
    </g>
    <defs>
      <clipPath id="clip0_2398_40882">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default BrazilFlag
